import { AlgoliaCustomSort, ISearchProduct } from '@monofront/types';
import { useInstantSearch } from 'react-instantsearch-core';
import Link from 'next/link';
import Hits from './Hits';
import { useTranslations } from 'next-intl';

interface IStateResults {
  customHasMoreHit?: boolean;
  customSort?: AlgoliaCustomSort<ISearchProduct>;
}
// "clickAnalytics=true&facetFilters=%5B%5B%22collections%3Anouveautes%22%5D%5D&facets=%5B%22collections%22%2C%22diets%22%2C%22ecoscoreMark%22%2C%22meta.marketing.nutriscore_grade%22%2C%22shelfs%22%2C%22values%22%2C%22vendor%22%5D&highlightPostTag=%3C%2Fais-highlight-0000000000%3E&highlightPreTag=%3Cais-highlight-0000000000%3E&hitsPerPage=40&maxValuesPerFacet=1000&page=0&ruleContexts=%5B%22collection_v2%22%2C%22nouveautes%22%2C%22collection-nouveautes%22%5D&tagFilters=&filters=NOT+tags%3Afirst-order-gift"
// "clickAnalytics=true&facetFilters=%5B%5B%22collection%3Anouveautes%22%5D%5D&facets=%5B%22collection%22%2C%22diets%22%2C%22ecoscoreMark%22%2C%22meta.marketing.nutriscore_grade%22%2C%22values%22%2C%22vendor%22%5D&hitsPerPage=40&maxValuesPerFacet=1000&page=0&query=&ruleContexts=%5B%22collection_v2%22%2C%22chips-et-biscuits-sales%22%2C%22collection-chips-et-biscuits-sales%22%5D&tagFilters=&filters=NOT+tags%3Afirst-order-gift"

const StateResults: React.FC<IStateResults> = ({ customSort }) => {
  const { results, indexUiState } = useInstantSearch();
  const hasResults = results && results.nbHits !== 0;

  const tCatalog = useTranslations('Catalog');

  if (!hasResults) {
    return (
      <>
        <div className="container">
          <p>{tCatalog('noResultsForQuery', { query: indexUiState.query })}</p>
          <p>
            {tCatalog('tryTo')}{' '}
            <Link href="/search" as={`/search?q=`} legacyBehavior>
              <a data-testid="StateResults-go-to-search-remove-filters">
                {tCatalog('removeFilters')}
              </a>
            </Link>{' '}
            {tCatalog('orTo')}{' '}
            <Link href="/search" as={`/search?q=`} legacyBehavior>
              <a data-testid="StateResults-go-to-update-search">
                {tCatalog('updateSearch')}
              </a>
            </Link>
          </p>
        </div>
        <style jsx>{`
          .container {
            margin-top: 60px;
            display: flex;
            align-items: center;
            flex-direction: column;
          }

          .container > p:first-child {
            margin-bottom: var(--space-2);
          }

          @media (max-width: 800px) {
            .container {
              padding: var(--padding-layout-sm);
            }
          }
        `}</style>
      </>
    );
  }

  return <Hits customSort={customSort} />;
};

export default StateResults;
